import styled from "styled-components";
import { H3 } from "@/lib/styles";

export const Container = styled.div`
`;

export const Heading = styled(H3)<{
  $hasIndex?: boolean;
}>`
  padding-top: ${({ $hasIndex }) =>
      $hasIndex ? "5rem" : ""};
  ${({ theme }) => theme.mediaQueries.laptop} {
    padding: 5rem 1.5rem 0;
  }
`;
